var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "personal-header__authorize-list" },
    [
      _c(
        "button",
        {
          staticClass: "personal-header__authorize-item",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.openLogin($event)
            }
          }
        },
        [_vm._v("\n    Вход\n  ")]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "personal-header__authorize-seporator" }, [
        _vm._v("/")
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "personal-header__authorize-item",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.openRegistration($event)
            }
          }
        },
        [_vm._v("\n    Регистрация\n  ")]
      ),
      _vm._v(" "),
      _c(
        "modal-vue-d",
        {
          attrs: { name: "auth-modal", width: 420 },
          on: { opened: _vm.openedModal }
        },
        [_c("auth-m", { ref: "auth", attrs: { "show-title": true } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }